import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "text-grey-9" }
const _hoisted_2 = { class: "text-grey-9" }
const _hoisted_3 = { class: "text-grey-9" }
const _hoisted_4 = { class: "text-grey-9" }
const _hoisted_5 = { class: "text-grey-9" }
const _hoisted_6 = { class: "text-grey-9" }

import { useFormatDate } from '../composables/formatDate'
import { useFormatTime } from '../composables/formatTime'
import { useQuasar } from 'quasar'
import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useUserStore } from '../store/useUserStore'
import { useI18n } from 'vue-i18n'


export default /*#__PURE__*/_defineComponent({
  __name: 'PreviousActivityItem',
  props: {
    time: {},
    toBePaidDistance: {},
    toBePaidHours: {},
    expenses: {},
    orders: {},
    status: {},
    date: {},
    fixBy: {},
    editedCount: {},
    lastUpdatedAt: {}
  },
  setup(__props: any, { expose: __expose }) {

const { t } = useI18n({ useScope: 'global' })
const timelineLabel = (key: string) => t(`timeline.${key}`)
const payPeriod = (key: string) => t(`payPeriod.${key}`)

//ripple stuff
const $q = useQuasar()
__expose({ $q })

const props = __props

const dateText = computed(() => {
  const formattedDate = useFormatDate(new Date(props.date), { language_choice: user.language })
  return `${formattedDate.weekday()}, ${formattedDate.month()} ${formattedDate.day()}`
})
const timeText = computed(() => {
  return useFormatTime(props.time, { format: 'h:mm', initTime: 'minutes' })
})
const expensesText = computed(() => {
  return props.expenses.toLocaleString(undefined, { style: 'currency', currency: 'USD' })
})
const fixByDate = computed(() => {
  if (!props.fixBy) return ''
  const formattedDate = useFormatDate(props.fixBy, { language_choice: user.language })
  return `${formattedDate.weekday()}, ${formattedDate.month()} ${formattedDate.day()}`
})

const user = storeToRefs(useUserStore())

return (_ctx: any,_cache: any) => {
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_badge = _resolveComponent("q-badge")!
  const _component_q_item = _resolveComponent("q-item")!
  const _directive_ripple = _resolveDirective("ripple")!

  return _withDirectives((_openBlock(), _createBlock(_component_q_item, {
    to: "/home-denied1",
    clickable: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_item_section, null, {
        default: _withCtx(() => [
          _createVNode(_component_q_item_label, { class: "text-h6 text-weight-regular text-black" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(dateText.value), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_q_item_label, {
            caption: "",
            lines: "2"
          }, {
            default: _withCtx(() => [
              _createElementVNode("strong", _hoisted_1, _toDisplayString(timeText.value), 1),
              _createTextVNode(" " + _toDisplayString(payPeriod('time')) + " • ", 1),
              _createElementVNode("strong", _hoisted_2, _toDisplayString(_ctx.toBePaidDistance), 1),
              _createTextVNode(" " + _toDisplayString(timelineLabel(_unref(user).distance.value)) + " • ", 1),
              _createElementVNode("strong", _hoisted_3, _toDisplayString(expensesText.value), 1),
              _createTextVNode(" " + _toDisplayString(payPeriod('expenses')) + " • ", 1),
              _createElementVNode("strong", _hoisted_4, _toDisplayString(_ctx.orders), 1),
              _createTextVNode(" " + _toDisplayString(payPeriod('orderItems')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_q_item_label, {
            caption: "",
            lines: "1"
          }, {
            default: _withCtx(() => [
              (_ctx.editedCount)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("strong", _hoisted_5, _toDisplayString(_ctx.editedCount), 1),
                    _createTextVNode(" " + _toDisplayString(payPeriod('edits')), 1)
                  ], 64))
                : _createCommentVNode("", true),
              (_ctx.lastUpdatedAt)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(" • "),
                    _createElementVNode("strong", _hoisted_6, _toDisplayString(_unref(useFormatDate)(new Date(_ctx.lastUpdatedAt), { language_choice: _unref(user).language }).month({
                month: 'short',
              })) + " " + _toDisplayString(_unref(useFormatDate)(new Date(_ctx.lastUpdatedAt), { language_choice: _unref(user).language }).day()) + " " + _toDisplayString(_unref(useFormatDate)(new Date(_ctx.lastUpdatedAt + ' CDT')).time()), 1),
                    _createTextVNode(" " + _toDisplayString(payPeriod('lastUpdated')), 1)
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_q_item_section, {
        side: "",
        top: ""
      }, {
        default: _withCtx(() => [
          (_ctx.status === 'approved')
            ? (_openBlock(), _createBlock(_component_q_badge, {
                key: 0,
                color: "positive",
                label: payPeriod('accepted')
              }, null, 8, ["label"]))
            : (_ctx.status === 'declined')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createVNode(_component_q_badge, {
                    color: "negative",
                    label: payPeriod('declined')
                  }, null, 8, ["label"]),
                  _createVNode(_component_q_item_label, {
                    caption: "",
                    class: "q-mt-xs text-negative"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("strong", null, _toDisplayString(payPeriod('fixBy')) + " " + _toDisplayString(fixByDate.value), 1)
                    ]),
                    _: 1
                  })
                ], 64))
              : (_ctx.status === 'incomplete')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _createVNode(_component_q_badge, {
                      color: "negative",
                      label: payPeriod('incomplete')
                    }, null, 8, ["label"]),
                    _createVNode(_component_q_item_label, {
                      caption: "",
                      class: "q-mt-xs text-negative"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("strong", null, _toDisplayString(payPeriod('fixBy')) + " " + _toDisplayString(fixByDate.value), 1)
                      ]),
                      _: 1
                    })
                  ], 64))
                : (_openBlock(), _createBlock(_component_q_badge, {
                    key: 3,
                    color: "grey",
                    label: payPeriod('processing')
                  }, null, 8, ["label"]))
        ]),
        _: 1
      })
    ]),
    _: 1
  })), [
    [_directive_ripple]
  ])
}
}

})